/*
 * rootSaga
 */

import { spawn, all, call } from 'redux-saga/effects';
import fasTag from '../components/Fastag/Listing/saga';
import fasTagDetail from '../components/Fastag/Detail/saga';
import payment from '../components/Payment/saga';
import passbook from '../components/Fastag/Passbook/saga';
import workflowSaga from '../pages/workflow/store/saga';
import marketPlaceSaga from '../pages/web-views/marketplace/store/saga';
import subscribeSaga from '../pages/web-views/subscribe/store/saga';
import referralSaga from '../pages/web-views/referral/store/saga';
import autoCompleteSaga from '../components/UI/Organisms/AutoComplete/store/sagas';
import updateConsignmentSaga from '../pages/update-consignment/store/saga';
import umsSaga from '../pages/ums/store/saga';
import consignerVehicles from '../pages/consigner/vehicles/store/saga';
import consignerPaymentSaga from '../pages/public/payments/store/saga';
import consignerPlanSaga from '../pages/public/plan/store/saga';
import fleetLoadConfirmationSaga from '../pages/public/fleet-load-confirmation/store/saga';
import operatorTdsDeclarationSaga from '../pages/public/operator-tds-declaration/store/saga';
import operatorUndertakingSaga from '../pages/public/operator-undertaking/store/saga';
import onboardingOperatorSaga from '../pages/web-views/onboarding-operator/store/saga';

export default function* rootSaga() {
  const sagas = [
    fasTag,
    fasTagDetail,
    payment,
    passbook,
    workflowSaga,
    marketPlaceSaga,
    subscribeSaga,
    referralSaga,
    autoCompleteSaga,
    updateConsignmentSaga,
    umsSaga,
    consignerVehicles,
    consignerPaymentSaga,
    consignerPlanSaga,
    fleetLoadConfirmationSaga,
    operatorTdsDeclarationSaga,
    operatorUndertakingSaga,
    onboardingOperatorSaga,

  ];
  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log(e);
          }
        }
      }),
    ),
  );
}
